import React from 'react';
import { StyledCard } from './styles';

const Card = ({ children, ...props }) => (
  <StyledCard {...props}>{children}</StyledCard>
);

export default Card;
